export const isHCoreLanding = (pathname) => {
  if (!pathname) return false;

  return (
    pathname === '/de/h-core' ||
    pathname === '/de/h-core/' ||
    pathname === '/en/h-core' ||
    pathname === '/en/h-core/'
  );
};
